"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledChip = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: #e8e8ed;\n  color: #9d9d9d;\n  height: 32px;\n  border-radius: 16px;\n  margin: 0px;\n  outline: none;\n  border: none;\n  font-size: 14px;\n  font-family: 'Raleway', sans-serif;\n  cursor: pointer;\n  width: fit-content;\n  display: inline-flex;\n  flex-direction: row;\n  justify-items: center;\n  align-items: center;\n\n  :hover {\n    background-color: #d7d7de;\n  }\n\n  &.pui-chip--size-small {\n    font-size: 80%;\n    height: 24px;\n    border-radius: 12px;\n    padding: 0px 12px;\n\n    .pui-icon-button--size-small {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  &.pui-chip--size-medium {\n    padding: 7px 12px;\n    height: 32px;\n    border-radius: 16px;\n    padding: 0px 16px;\n  }\n\n  &.pui-chip--size-large {\n    font-size: 120%;\n    height: 42px;\n    border-radius: 22px;\n    padding: 0px 22px;\n  }\n\n  &.pui-chip--disabled {\n    opacity: 0.6;\n    cursor: default;\n  }\n\n  &.pui-chip--colorfull {\n    background-color: ", "38;\n    color: ", ";\n  }\n\n  &.pui-chip--colorfull:hover {\n    background-color: ", "62;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledChip = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.color.background;
}, function (props) {
  return props.color.foreground;
}, function (props) {
  return props.color.background;
});

exports.StyledChip = StyledChip;

var Chip = function Chip(_ref) {
  var element = _ref.element,
      className = _ref.className,
      size = _ref.size,
      color = _ref.color,
      disabled = _ref.disabled,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["element", "className", "size", "color", "disabled", "children"]);

  var theme = (0, _useTheme["default"])();

  if (size === 'default') {
    size = 'medium';
  }

  var elementProps = _objectSpread(_objectSpread({}, props), {}, {
    className: (0, _clsx["default"])(className, {
      'pui-chip--disabled': Boolean(disabled),
      'pui-chip--colorfull': color !== 'default'
    }, "pui-chip--size-".concat(size)),
    color: {
      background: 'transparent',
      foreground: 'transparent'
    }
  });

  if (element) {
    elementProps.as = element;
  }

  if (theme.palette[color]) {
    elementProps.color = {
      background: theme.palette[color][50],
      foreground: theme.palette[color][500]
    };
  }

  return /*#__PURE__*/_react["default"].createElement(StyledChip, elementProps, children);
};

Chip.propTypes = {
  /**
   * Element type
   */
  element: _propTypes["default"].elementType,

  /**
   * Chip size
   */
  size: _propTypes["default"].string,
  //PropTypes.oneOf(['default', 'small', 'medium', 'large']),

  /**
   * Chip color
   */
  color: _propTypes["default"].string,
  // PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * Chip is disabled?
   */
  disabled: _propTypes["default"].bool
};
Chip.defaultProps = {
  element: 'div',
  size: 'default',
  color: 'default',
  disabled: false
};
var _default = Chip;
exports["default"] = _default;